









































import { Component, Vue } from 'vue-property-decorator';
import LoginModal from '@/modules/users/components/LoginModal.vue';
import RegisterModal from '@/modules/users/components/RegisterModal.vue';
import { namespace } from 'vuex-class';

const userStore = namespace('UserStore');

@Component({
  name: 'Toolbar',
  components: {
    LoginModal,
    RegisterModal,
  },
})
export default class Toolbar extends Vue {
  @userStore.Action
  updateLoginModalVisibility!: (showLoginModal: boolean) => void;
  @userStore.Action
  updateRegisterModalVisibility!: (showRegisterModal: boolean) => void;
  @userStore.Action
  logout!: () => void;
  private drawer = false;
  private isSmallButton = false;
  @userStore.State
  private isLogged?: boolean;
}
